import { Mail, MessageCircle } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button, Modal } from "./ui";
import { api, errMsg } from "../lib/api";

type Props = { kind: "invoice" | "receipt" | "reminder"; refId: string; label?: string; size?: "sm" | "md" | "icon"; variant?: any; testId?: string };

export function EmailButton({ kind, refId, size = "sm", variant = "outline", testId }: Props) {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/email/send", { kind, ref_id: refId, to: "both" }); toast.success(`Email terkirim ke ${data.results.map((r: any) => r.email).join(", ")}`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <Button type="button" variant={variant} size={size} disabled={busy} onClick={send} data-testid={testId || `email-${kind}-${refId}`} title="Kirim via email ke siswa & wali"><Mail className="h-4 w-4" /> {size !== "icon" && (busy ? "…" : "Kirim Email")}</Button>;
}

export function WaButton({ kind, refId, label = "Kirim WA", size = "sm", variant = "outline", testId }: Props) {
  const [res, setRes] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/wa/send", { kind, ref_id: refId, to: "both", send: true });
      setRes(data);
      if (data.auto) toast.success(`WA terkirim otomatis ke ${data.results.filter((r: any) => r.sent).length} nomor`);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <Button type="button" variant={variant} size={size} disabled={busy} onClick={send} data-testid={testId || `wa-${kind}-${refId}`} title="Kirim via WhatsApp ke siswa & wali">
        <MessageCircle className="h-4 w-4" /> {size !== "icon" && (busy ? "…" : label)}
      </Button>
      <Modal open={!!res} onClose={() => setRes(null)} title="Kirim via WhatsApp" testId="wa-modal">
        {res && (
          <div className="space-y-3 text-sm">
            <p className={res.auto ? "text-emerald-700" : "text-amber-700"}>{res.auto ? "Pengiriman otomatis (Twilio) aktif." : "Pengiriman otomatis belum dikonfigurasi — klik tombol di bawah untuk membuka WhatsApp dengan pesan yang sudah terisi."}</p>
            <pre className="whitespace-pre-wrap rounded-md bg-muted p-3 text-xs" data-testid="wa-preview">{res.text}</pre>
            <div className="flex flex-wrap gap-2">
              {res.results.map((r: any) => (
                <a key={r.number} href={r.wa_link} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-md bg-emerald-600 px-3 py-2 text-white text-xs font-semibold hover:bg-emerald-700" data-testid={`wa-open-${r.label.toLowerCase()}`}>
                  <MessageCircle className="h-3.5 w-3.5" /> {r.label} · +{r.number} {r.sent ? "· terkirim ✓" : r.error ? "· gagal, buka manual" : ""}
                </a>
              ))}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}
